import React from "react";
import { Box, Link, Typography } from "@mui/material";

function Footer() {
    return (
        <Box
            component="footer"
            sx={{ textAlign: "center", py: 3, color: "text.secondary" }}>
            <Typography variant="body2">
                Copyright © 2026 Quick Tools App — Designed by{" "}
                <Link
                    href="https://bilalabdulhadi.com"
                    target="_blank"
                    rel="noreferrer"
                    color="inherit">
                    Bilal Abdulhadi
                </Link>
            </Typography>
        </Box>
    );
}

export default Footer;
